// Every downloaded CSV builds its cells with `${}` interpolation, which turns a
// SQL NULL (arriving here as JS `null`) into the literal text "null". A missing
// value has to read as an empty cell instead — otherwise consumers of the export
// have to treat both "" and "null" as absent, and "null" looks like a value.
// Wrap every interpolated cell of a download CSV in this.
function csvValue(value) {
  return value === null || value === undefined ? "" : value;
}

export default csvValue;
